<div class="footer">
  <span class="footer-text">© 2025 Kochikachar Bornomala</span>
</div>
